var VALID_EMAIL_REGEX = /^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

$(document).ready(function() {
	$("#txtDealerZip").on("keydown", function (event) { numberOnly.call(this, event, 5, false); });
	$("#txtDealerPhoneNumber").mask("(999)999-9999"); 
	$("#btnDealerSubmit").on("click", saveDealerPartnerForm);
});

function saveDealerPartnerForm() {
	let $divSel = ".scaffolding--content";
	let payload = {
		dealerName: document.getElementById('txtDealerName').value,
		postalCd: document.getElementById('txtDealerZip').value,
		firstNm: document.getElementById('txtDealerYourNameFirst').value,
		lastNm: document.getElementById('txtDealerYourNameLast').value,
		phoneNum: document.getElementById('txtDealerPhoneNumber').value,
		dmsType: document.getElementById('ddlDMSType').value,
		email: document.getElementById('txtDealerEmail').value,
		referredBy: document.getElementById('ddlDealerChooseHow').value
	};
	
	if (validateDealerPartner(payload) == true) {
		// Google Analytic Tracking - DP1238
		gtag('event',  "signUp", {
			  'event_category' : "dealerPartnerRegister"
		}); // END  Google Analytic Tracking
		provcommon.block($divSel)
			.then(res => axios.post("public/resources/dealerPartnerRegister", payload, { responseType: "json" }))
			.then(res => parseSaveFormResponse(res))
			.catch(err => alert("Something went wrong with the request."))
			.finally(() => provcommon.unblock($divSel));		
	}
}

function parseSaveFormResponse(res) {
	return new Promise((resolve, reject) => {
		if (res.data != null && res.data.responseCode == "success") {
			$('#dealersignup-form').hide();
			$('#dealerPartner-fault').hide();
			$('#dealerPartner-error').hide();
			$('#dealerPartner-success').show();
			$('#dealerPartnerResults').show();
		} else {
			$('#dealersignup-form').hide();
			$('#dealerPartner-success').hide();
			$('#dealerPartner-error').hide();
			$('#dealerPartner-fault').show();
			$('#dealerPartnerResults').show();			
		}
		resolve(res);
	});
}

function validateDealerPartner(payload) {
	var flag = true;
	var msg = '';
	var message = document.getElementById('confirmMessage');
	message.innerHTML = "";
	
	if (payload.dealerName == '') {
		flag = false;
		$('#rfvDealerName').show();
	} else {
		$('#rfvDealerName').hide();
	}
	
	if (payload.dmsType == '') {
		flag = false;
		$('#rfvDMSType').show();
	} else {
		$('#rfvDMSType').hide();
	}
	
	if (payload.phoneNum == '') {
		flag = false;
		$('#rfvDealerPhone').show();
	} else {
		var tempNum = payload.phoneNum.replace(/[^\d]/g, '');
		if (tempNum.length != 10) {
			flag = false;
			msg = msg + "Please enter a 10 digit phone number.<br>";
			$('#rfvDealerPhone').show();
		} else {
			$('#rfvDealerPhone').hide();
		}
	}
	
	
	if(payload.postalCd == ''){
		flag = false;
		$('#rfvDealerZip').show();
	} else {
		var tempZip = payload.postalCd.replace(/[^\d]/g, '');
		if(tempZip.length != 5){
			flag = false;
			msg = msg + "Please enter a 5 digit zip code.<br>";
			$('#rfvDealerZip').show();
		}else
			$('#rfvDealerZip').hide();
	}
	
	if (payload.firstNm == '') {
		flag = false;
		$('#rfvDealerYourFirstName').show();
	} else {
		$('#rfvDealerYourFirstName').hide();
	}
	
	if (payload.lastNm == '') {
		flag = false;
		$('#rfvDealerYourLastName').show();
	} else {
		$('#rfvDealerYourLastName').hide();
	}
	
	if (payload.email == ''|| VALID_EMAIL_REGEX.test(payload.email) === false) {
		flag = false;
		msg = msg + "Please enter a valid email address.<br>";
		$('#rfvDealerEmail').show();
	} else {
		$('#rfvDealerEmail').hide();
	}
	
	if (payload.referredBy == '') {
		msg = msg + "Please select how you were referred to us.<br>";
		flag = false;
		$('#revDealerChooseHow').show();
	} else {
		$('#revDealerChooseHow').hide();
	}
	
	if (flag == false) {
		msg = msg + "Please enter the remaining fields.";
	}
	
	message.innerHTML = msg;	
	
	return flag;
}

function loadDealerPartnerForm(){
	provajax.load("#outerformdiv", "#outerformdiv", "im2?to=dealerPartnerForm");	
}

function numberOnly() {
	var event = arguments[0];
	var maxLength = arguments[1];
	var allowDecimal = arguments[2];
	var key = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode;

	/*
* Check if the input is from touch screen/mobile. Triggers keyup event that clears the field if the values are not valid.
*/
	if (key == 229 || key == 0 || (key == 86 && event.ctrlKey === true)) {
		$(this).on("keyup", function (ne) {
			var regex = new RegExp(/[^0-9]/g);
			var str = $(this).val();
			if (regex.test(str) == true) {
				$(this).val(str.replace(regex, ""));
			}
		});
	} else {
		var keycodes;
		if (allowDecimal) {
			keycodes = [46, 8, 9, 27, 13, 110, 190];
		} else {
			keycodes = [46, 8, 9, 27, 13];
		}

		// Allow: backspace, delete, tab, escape, enter and .
		if ($.inArray(key, keycodes) !== -1
// Allow: Ctrl+A
|| (key == 65 && event.ctrlKey === true)
// Allow: Ctrl+C
|| (key == 67 && event.ctrlKey === true)
// Allow: Ctrl+X
|| (key == 88 && event.ctrlKey === true)
// Allow: home, end, left, right
|| (key >= 35 && key <= 39)) {
			// let it happen, don't do anything
			return;
		}

		// Ensure that it is a number and stop the keypress
		if ((event.shiftKey || (key < 48 || key > 57)) && (key < 96 || key > 105)) {
			event.preventDefault();
		}

		if (this.value && this.value.length >= maxLength) {
			event.preventDefault();
		}
	}
}
